/**
 * Home.jsx
 * ---------------------------------------------------------------------------
 * The main single-page CaseSignalHQ composition. Mounted at "/".
 *
 * On mount, it inspects the URL query string for `interest` and `from`
 * parameters set by the persistent CoConsoleX CTA, then forwards them to
 * the FirmsSection via session storage so the form pre-fills without
 * lifting state through every section.
 */

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Hero from "../components/sections/Hero.jsx";
import PlatformOverview from "../components/sections/PlatformOverview.jsx";
import IndividualIntake from "../components/sections/IndividualIntake.jsx";
import FirmsSection from "../components/sections/FirmsSection.jsx";
import DataAtRest from "../components/sections/DataAtRest.jsx";
import AIEnablement from "../components/sections/AIEnablement.jsx";
import FractionalCounsel from "../components/sections/FractionalCounsel.jsx";
import TrustSection from "../components/sections/TrustSection.jsx";
import FinalCTA from "../components/sections/FinalCTA.jsx";

export default function Home() {
  const { search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const interest = params.get("interest");
    const from = params.get("from");
    if (interest) {
      sessionStorage.setItem(
        "csx:firmInquiryPrefill",
        JSON.stringify({ interest, from }),
      );
      // strip query, keep hash, then scroll to firms
      navigate({ pathname: "/", hash: hash || "#firms" }, { replace: true });
      setTimeout(() => {
        const el = document.getElementById("firms");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    } else if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  }, [search, hash, navigate]);

  return (
    <>
      <Hero />
      <PlatformOverview />
      <IndividualIntake />
      <FirmsSection />
      <DataAtRest />
      <AIEnablement />
      <FractionalCounsel />
      <TrustSection />
      <FinalCTA />
    </>
  );
}
